import dayjs from 'dayjs';

import type {ConferenceApiModel} from '../../../api/conference';
import type {Nullable} from '../../utility-types';

import {not} from '../../conditionalUtils';
import {datetimeObjToISOString} from '../../datetime';
import {isDefined} from '../../typecheck';
import {getConferenceAbleToStartDate} from './getConferenceAbleStartDate';
import {isConferenceExpired} from './isConferenceExpired';

export const isConferenceStartEnabled = (
  conference?: Nullable<ConferenceApiModel>,
) => {
  if (isDefined(conference)) {
    const isReadyToStart = dayjs().isAfter(
      dayjs(datetimeObjToISOString(getConferenceAbleToStartDate(conference))),
    );

    const isNotPast = conference.status !== 'past';

    return isReadyToStart && isNotPast && not(isConferenceExpired(conference));
  }

  return false;
};
